import { Avatar, Divider, ButtonBase, Button, Chip, FormLabel, Grid, CardContent } from '@material-ui/core';
import { AddRounded, CheckCircleRounded, CloseRounded, DateRangeRounded, DescriptionRounded, EventBusyRounded, FolderRounded, HomeWorkRounded, MailRounded, MoreHoriz, MoreHorizRounded, PeopleAltRounded, PersonRounded, PhoneRounded, ReceiptRounded, RoomRounded, RouterRounded, SchoolRounded, WorkRounded } from '@material-ui/icons';
import { getInfosDashboard, deleteRelation, searchOpcoBillings } from '@webapps/business';
import { useQuery, useMutation } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useEffect, useState, useRef } from 'react';
import TagIcon from 'components/Icons/Tag';
import { FormattedDate } from 'react-intl';
import { downloadCv, generateBilling } from '@webapps/business';
import { useAuth, useToast, FormikAutocompletePx, FormikTextFieldPx } from '@webapps/reactjs-tech-components';
import { useFormik } from 'formik';
import BillingModel from './BillingModel';

const BillingCard = ({ info, refetch }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { addToast } = useToast();
  const contentRefs = useRef([]);

  const formik = useFormik({
    initialValues: {
      montantTotal: info?.opcoBilling?.totalAmount,
      lignes: info?.opcoBilling?.lines?.map(line => ({
        montant: line.amount,
        quantite: line.quantity,
        numeroEcheance: line.dueDate,
        natureLigne: line.billingType
      }))
    },
    onSubmit: () => {    
      handleGeneratePDFWithNode();
    }
  });

  const {
    error: errorGenerateBilling,
    isLoading: isLoadingGenerateBilling,
    isSuccess: isSuccessGenerateBilling,
    mutateAsync: mutateGenerateBilling,
  } = useMutation(generateBilling);


  useEffect(() => {
    if (isSuccessGenerateBilling) {
      addToast({
        status: 'success',
        message: 'La facture a été généré avec succès',
      });
      refetch();
    } else if (errorGenerateBilling) {
      console.log(errorGenerateBilling?.response)
      addToast({
        status: 'error',
        message: `Une erreur est survenue lors de la génération de la facture : ${errorGenerateBilling?.response?.data?.description || ''}`,
      });
    }
    
  }, [errorGenerateBilling, isSuccessGenerateBilling]);

  const handleGeneratePDFWithNode = async () => {
    if (!contentRefs.current) {
      console.error("No content elements found.");
      return;
    }

    const rawHTML = contentRefs.current.innerHTML;

    const container = document.createElement("div");
    container.innerHTML = rawHTML;

    const processedHTML = container.innerHTML;

    await mutateDownloadCv({
      data: { html: processedHTML },
    });
  };

  const {
    error: errorDownloadCv,
    isLoading: isLoadingDownloadCv,
    isSuccess: isSuccessDownloadCv,
    data: dataObject,
    mutateAsync: mutateDownloadCv,
  } = useMutation(downloadCv);

  useEffect(() => {
    if (isSuccessDownloadCv) {
      const formData = new FormData();

      formData.append('file', dataObject);
      formData.append('data', new Blob([JSON.stringify(formik.values)], { type: 'application/json' }));

      mutateGenerateBilling({ id: opcoRecord?.id, formData });

    } else if (errorDownloadCv) {
      addToast({
        status: 'error',
        message: 'Erreur lors de la création de la facture',
      });
    }
  }, [errorDownloadCv, isSuccessDownloadCv]);

  return (
    <div className={classes.container}>
      <CardContent className={classes.cardContainer}>
        <div className={css({ display: 'flex', justifyContent: 'space-between' })}>
          <div>
            <div className={cx(global.title)}>
              {info?.opcoBilling?.totalAmount}€
            </div>
          </div>
          <div>
          <ButtonBase onClick={() => console.log(';)')} className={global.buttonBase}>
            <MoreHorizRounded className={global.buttonIcon} />
          </ButtonBase>
          </div>
        </div>
        <div>
          <div className={cx(global.infoText, classes.address)}>
            <TagIcon className={global.infoIcon} />
            <div>{`N° de facture : ${info?.opcoBilling?.internalBillingId || "Non émise"}`}</div>
          </div>
          <div className={cx(global.infoText, classes.address)}>
            <DateRangeRounded className={global.infoIcon} />
            Envoyée le :{' '} {info?.opcoBilling?.sentAt ?
              <FormattedDate
                day="numeric"
                month="numeric"
                value={info?.opcoBilling?.sentAt}
                year="numeric"
              /> : "Non émise"}
          </div>
        </div>
        <div className={classes.buttons}>
          <Button variant="contained" color="primary" onClick={formik.handleSubmit}>
            Envoyer la facture
          </Button>
        </div>
      </CardContent>
      <BillingModel billingData={formik.values} contentRefs={contentRefs} />
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    backgroundColor: "white",
    borderRadius: 16,
    padding: spacing(2.5),
  },
  cardContainer: {
    textAlign: 'center',
    // padding: spacing(0, 0, 2.5, 0),
    padding: spacing(0, 0, 0, 0),
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(2),
  },
  buttonsContainer: {
    display: 'flex',
    columnGap: 10,
  },
  name: {
    marginLeft: spacing(2),
    display: 'flex',
    textAlign: 'start',
    fontFamily: 'Montserrat',
    wordBreak: 'break-all',
  },
  divider: {
    margin: "8px 0px",
  },
  address: {
    display: 'flex',
    marginTop: spacing(0.5),
    textAlign: 'start',
    alignItems: 'center',
  },
  avatar: {
    height: 60,
    width: 60,
    border: '1px solid #C0D9FF',
  },
  photo: {
    marginBottom: spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
    rowGap: 10,
  },
  buttonHover: {
    "&:hover": {
      backgroundColor: "#0060F9",
      color: "white!important",
    },
  },
  toComplete: {
    backgroundColor: '#FA8100',
    color: "white",
    fontSize: 11,
    padding: "2px 5px",
    marginLeft: '5px',
    borderRadius: '4px',
  }
});

export default BillingCard;
